import { Reveal } from "./Reveal";
import { InfinityGlyph } from "./Wordmark";

const STEPS = [
  ["01", "Capture everything", "Add photos, videos, voice notes, letters and recipes from every chapter of your family's life."],
  ["02", "AI brings order", "Chrono transcribes voices, recognises people and places, and weaves it all into a searchable timeline — The Family Loop."],
  ["03", "Relive & ask", "Explore memories by person, place or year, and ask Chrono AI anything about your family's story."],
  ["04", "Pass it on", "Invite loved ones as Trusted Stewards so your legacy keeps growing for the generations that follow."],
];

const CapsuleCard = () => (
  <Reveal
    data-testid="chrono-capsules-card"
    className="cl-card relative mt-6 overflow-hidden p-8 sm:p-12 md:flex md:items-center md:gap-12"
  >
    <div className="cl-glow pointer-events-none absolute -right-24 -top-24 h-80 w-80" />
    <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full border border-[#E7C99D]/40 sm:h-24 sm:w-24">
      <InfinityGlyph className="h-7 w-14 sm:h-8 sm:w-16" strokeWidth={1.6} />
    </div>
    <div className="relative mt-8 md:mt-0">
      <p className="text-[11px] font-medium tracking-[0.32em] text-[#79B9FF]">CHRONO CAPSULES</p>
      <h3 className="cl-heading mt-4 text-3xl text-[#E6EDF4] sm:text-4xl">Messages that travel across time</h3>
      <p className="mt-5 max-w-3xl text-[15px] leading-relaxed text-[#9AAABD]">
        Seal a heartfelt message with photos, video or voice and lock it for a future date or milestone — a 10th
        birthday, a wedding, 25 years from now. Your loved one receives a beautiful dedication today; the full capsule
        opens on the exact day you choose.
      </p>
    </div>
  </Reveal>
);

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="section-how-it-works" className="cl-section relative">
    <div className="cl-container">
      <Reveal className="max-w-2xl">
        <p className="cl-kicker">HOW IT WORKS</p>
        <h2 className="cl-heading mt-5 text-4xl leading-[1.1] text-[#E6EDF4] sm:text-5xl">
          From scattered memories to a living legacy
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[#9AAABD] sm:text-lg">
          Four quiet steps turn a lifetime of moments into a story your family can return to — forever.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {STEPS.map(([num, title, body], i) => (
          <Reveal key={num} delay={i * 110} data-testid={`how-step-${num}`} className="cl-card cl-card-hover flex flex-col p-8">
            <span className="cl-heading text-4xl text-[#E7C99D]">{num}</span>
            <span className="mt-6 h-px w-10 bg-[#E7C99D]/40" />
            <h3 className="mt-6 text-xl font-normal text-white">{title}</h3>
            <p className="mt-4 text-[14.5px] leading-relaxed text-[#9AAABD]">{body}</p>
          </Reveal>
        ))}
      </div>

      <CapsuleCard />
    </div>
  </section>
);
